<script>
import removeEmojis from '@utils/remove-emojis'
import { Field } from 'vee-validate'

export default {
  components: {
    Field,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
    validCheck: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isInputFocused: false,
    }
  },

  computed: {
    isChecked() {
      return !!this.value || this.isInputFocused
    },
  },

  watch: {
    isInputFocused: function () {
      if (!this.isInputFocused) {
        this.$emit('change', this.value)
      }
    },
  },

  methods: {
    onCheckboxInput() {
      if (this.value) {
        this.$emit('input', '')
        this.$emit('change', '')
      } else {
        this.$refs.otherInput.focus()
      }
    },

    removeEmojis,
  },
}
</script>
<template>
  <div>
    <b-form-checkbox
      size="lg"
      :checked="isChecked"
      class="mr-2 mt-1 d-inline"
      @change="onCheckboxInput"
    >
      <span>Other</span>
    </b-form-checkbox>
    <Field
      v-slot="{ field }"
      :model-value="value"
      name="otherInput"
      :rules="{ blank_text: isChecked }"
    >
      <b-form-textarea
        v-bind="field"
        ref="otherInput"
        size="sm"
        class="d-inline otherInput"
        :class="{ 'is-invalid': isChecked && !validCheck }"
        rows="2"
        :formatter="removeEmojis"
        :placeholder="placeholder"
        @focus="isInputFocused = true"
        @blur="isInputFocused = false"
        @input="$emit('input', $event)"
      />
    </Field>
  </div>
</template>

<style lang="scss">
@import '@variables';
.otherInput {
  margin-top: 12.5px;

  &::placeholder {
    font-size: 16px;
    font-weight: 400;
    line-height: 23px;
  }
}
.is-invalid {
  &::placeholder {
    color: #dc3545;
  }

  color: black;

  &,
  .vs__dropdown-toggle,
  .scrollableCheckboxGroup {
    border-color: $alert-danger-icons !important;
  }
}
</style>
